import axios from 'axios';
import { Formik } from 'formik';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { INQUIRY_POSTREQ } from '../../constants/paths/api';
import SuccessOrFailure from '../successOrFailure';
import { inquiryInitialValues, inquirySchema } from './inquiry.schema';
import * as StyledInquiry from './inquiry.styles';
import InquiryFormFields from './inquiryFormFields';

interface Props {}

const Inquiry: FC<Props> = () => {
	const { t } = useTranslation('generalForm');
	const [hasSubmitted, setHasSubmitted] = useState(false);
	const [hasSubmittedSuccessfully, setHasSubmittedSuccessfully] = useState(false);
	const [error, setError] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	const onSubmit = (values, actions) => {
		axios
			.post(INQUIRY_POSTREQ, values)
			.then(response => {
				actions.setSubmitting(false);
				setHasSubmitted(true);
				if (response.data.error) {
					setError(response.data.error);
					setErrorMessage(response.data.errorMessage);
				} else {
					setHasSubmittedSuccessfully(true);
					window.scrollTo(0, 0);
				}
			})
			.catch(e => {
				actions.setSubmitting(false);
				setHasSubmitted(true);
				setError(true);
				setErrorMessage(e.errorMessage);
			});
	};

	return (
		<StyledInquiry.Wrapper>
			{!hasSubmittedSuccessfully && (
				<Formik
					initialValues={inquiryInitialValues}
					enableReinitialize
					validationSchema={inquirySchema}
					onSubmit={onSubmit}>
					{({ handleSubmit, isSubmitting }) => (
						<form onSubmit={handleSubmit}>
							<InquiryFormFields isSubmitting={isSubmitting} />
						</form>
					)}
				</Formik>
			)}
			<SuccessOrFailure
				hasSubmitted={hasSubmitted}
				success={!error}
				messageArray={[t('successMessage')]}
				errorMessage={errorMessage}
			/>
		</StyledInquiry.Wrapper>
	);
};

export default Inquiry;
